<nav class="sidebar-nav">
  <div class="sidebar-top">
    <ul class="nav-links">
      <li>
        <a
          class="nav-link"
          routerLink="/admin/dashboard"
          routerLinkActive="active"
        >
          <span class="material-symbols-rounded">bar_chart_4_bars</span>
          <span>{{ "admin.sidebar.dashboard" | translate }}</span>
        </a>
      </li>
      <li>
        <a
          class="nav-link"
          routerLink="/admin/converted-files"
          routerLinkActive="active"
        >
          <span class="material-symbols-rounded">folder</span>
          <span>{{ "admin.sidebar.convertedFiles" | translate }}</span>
        </a>
      </li>
      @if (!environment.isSuperAdmin) {
        <li>
          <a
            class="nav-link"
            routerLink="/admin/users"
            routerLinkActive="active"
          >
            <span class="material-symbols-rounded">group</span>
            <span>{{ "admin.sidebar.users" | translate }}</span>
          </a>
        </li>
      }
      @if (user$ | async; as user) {
        @if (user.profile == "SuperAdmin" && environment.isSuperAdmin) {
          <li>
            <a
              class="nav-link"
              routerLink="/admin/companies"
              routerLinkActive="active"
            >
              <span class="material-symbols-rounded">source_environment</span>
              <span>{{ "admin.sidebar.companies" | translate }}</span>
            </a>
          </li>
        }
      }
    </ul>
  </div>
</nav>
